export const BUTTON_CLASSNAMES = {
  'solid-neutral': '',
  'solid-primary': 'btn-primary',
  'solid-secondary': 'btn-secondary',
  'solid-grey':
    'border-none bg-neutral/20 text-neutral hover:bg-neutral hover:text-neutral-content',
  'solid-light':
    'border-none bg-neutral/10 text-neutral hover:bg-neutral/20 hover:text-neutral',
  'outline-neutral': 'btn-outline',
  'outline-primary': 'btn-outline btn-primary',
  'outline-secondary': 'btn-outline btn-secondary',
  'outline-light':
    'btn-outline border-neutral/20 hover:bg-neutral/10 hover:border-transparent hover:text-neutral',
  'outline-grey':
    'btn-outline border-neutral/50 hover:bg-neutral hover:border-transparent hover:text-neutral-content',
  text: 'btn-ghost',
  'text-link': 'btn-link',
  'outline-danger': 'btn-outline btn-error'
}

export const BUTTON_SIZES = {
  sm: "btn-sm",
  md: "",
  lg: "btn-lg",
}